// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/group.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { Principal, Subject } from "./identity_pb.js";
import { ResourceType } from "./event_pb.js";

/**
 * ResourceRole represents roles that can be assigned to groups on resources
 * These map directly to the roles defined in backend/db/rule/rbac/role/role.go
 *
 * @generated from enum gitpod.v1.ResourceRole
 */
export enum ResourceRole {
  /**
   * @generated from enum value: RESOURCE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Organization roles
   *
   * @generated from enum value: RESOURCE_ROLE_ORG_ADMIN = 1;
   */
  ORG_ADMIN = 1,

  /**
   * @generated from enum value: RESOURCE_ROLE_ORG_MEMBER = 2;
   */
  ORG_MEMBER = 2,

  /**
   * @generated from enum value: RESOURCE_ROLE_ORG_RUNNERS_ADMIN = 50;
   */
  ORG_RUNNERS_ADMIN = 50,

  /**
   * @generated from enum value: RESOURCE_ROLE_ORG_PROJECTS_ADMIN = 51;
   */
  ORG_PROJECTS_ADMIN = 51,

  /**
   * @generated from enum value: RESOURCE_ROLE_ORG_AUTOMATIONS_ADMIN = 52;
   */
  ORG_AUTOMATIONS_ADMIN = 52,

  /**
   * @generated from enum value: RESOURCE_ROLE_ORG_GROUPS_ADMIN = 53;
   */
  ORG_GROUPS_ADMIN = 53,

  /**
   * @generated from enum value: RESOURCE_ROLE_ORG_AUDIT_LOG_READER = 64;
   */
  ORG_AUDIT_LOG_READER = 64,

  /**
   * Group roles
   *
   * @generated from enum value: RESOURCE_ROLE_GROUP_ADMIN = 3;
   */
  GROUP_ADMIN = 3,

  /**
   * @generated from enum value: RESOURCE_ROLE_GROUP_VIEWER = 4;
   */
  GROUP_VIEWER = 4,

  /**
   * User roles
   *
   * @generated from enum value: RESOURCE_ROLE_USER_IDENTITY = 5;
   */
  USER_IDENTITY = 5,

  /**
   * @generated from enum value: RESOURCE_ROLE_USER_VIEWER = 6;
   */
  USER_VIEWER = 6,

  /**
   * @generated from enum value: RESOURCE_ROLE_USER_ADMIN = 7;
   */
  USER_ADMIN = 7,

  /**
   * Environment roles
   *
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_IDENTITY = 8;
   */
  ENVIRONMENT_IDENTITY = 8,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_ADMIN = 9;
   */
  ENVIRONMENT_ADMIN = 9,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_USER = 10;
   */
  ENVIRONMENT_USER = 10,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_VIEWER = 11;
   */
  ENVIRONMENT_VIEWER = 11,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_RUNNER = 12;
   */
  ENVIRONMENT_RUNNER = 12,

  /**
   * Runner roles
   *
   * @generated from enum value: RESOURCE_ROLE_RUNNER_IDENTITY = 13;
   */
  RUNNER_IDENTITY = 13,

  /**
   * @generated from enum value: RESOURCE_ROLE_RUNNER_ADMIN = 14;
   */
  RUNNER_ADMIN = 14,

  /**
   * @generated from enum value: RESOURCE_ROLE_RUNNER_LOCAL_ADMIN = 15;
   */
  RUNNER_LOCAL_ADMIN = 15,

  /**
   * @generated from enum value: RESOURCE_ROLE_RUNNER_MANAGED_ADMIN = 16;
   */
  RUNNER_MANAGED_ADMIN = 16,

  /**
   * @generated from enum value: RESOURCE_ROLE_RUNNER_USER = 17;
   */
  RUNNER_USER = 17,

  /**
   * @generated from enum value: RESOURCE_ROLE_RUNNER_CONFIGURATION_READER = 18;
   */
  RUNNER_CONFIGURATION_READER = 18,

  /**
   * Host authentication token roles
   *
   * @generated from enum value: RESOURCE_ROLE_HOST_AUTHENTICATION_TOKEN_ADMIN = 19;
   */
  HOST_AUTHENTICATION_TOKEN_ADMIN = 19,

  /**
   * @generated from enum value: RESOURCE_ROLE_HOST_AUTHENTICATION_TOKEN_UPDATER = 20;
   */
  HOST_AUTHENTICATION_TOKEN_UPDATER = 20,

  /**
   * Project roles
   *
   * @generated from enum value: RESOURCE_ROLE_PROJECT_ADMIN = 21;
   */
  PROJECT_ADMIN = 21,

  /**
   * @generated from enum value: RESOURCE_ROLE_PROJECT_USER = 22;
   */
  PROJECT_USER = 22,

  /**
   * @generated from enum value: RESOURCE_ROLE_PROJECT_EDITOR = 23;
   */
  PROJECT_EDITOR = 23,

  /**
   * Environment service roles
   *
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_SERVICE_ADMIN = 24;
   */
  ENVIRONMENT_SERVICE_ADMIN = 24,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_SERVICE_VIEWER = 25;
   */
  ENVIRONMENT_SERVICE_VIEWER = 25,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_SERVICE_USER = 26;
   */
  ENVIRONMENT_SERVICE_USER = 26,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_SERVICE_ENV = 27;
   */
  ENVIRONMENT_SERVICE_ENV = 27,

  /**
   * Environment task roles
   *
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_TASK_ADMIN = 28;
   */
  ENVIRONMENT_TASK_ADMIN = 28,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_TASK_VIEWER = 29;
   */
  ENVIRONMENT_TASK_VIEWER = 29,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_TASK_USER = 30;
   */
  ENVIRONMENT_TASK_USER = 30,

  /**
   * @generated from enum value: RESOURCE_ROLE_ENVIRONMENT_TASK_ENV = 31;
   */
  ENVIRONMENT_TASK_ENV = 31,

  /**
   * Service account roles
   *
   * @generated from enum value: RESOURCE_ROLE_SERVICE_ACCOUNT_IDENTITY = 32;
   */
  SERVICE_ACCOUNT_IDENTITY = 32,

  /**
   * @generated from enum value: RESOURCE_ROLE_SERVICE_ACCOUNT_ADMIN = 33;
   */
  SERVICE_ACCOUNT_ADMIN = 33,

  /**
   * @generated from enum value: RESOURCE_ROLE_AGENT_EXECUTION_USER = 35;
   */
  AGENT_EXECUTION_USER = 35,

  /**
   * @generated from enum value: RESOURCE_ROLE_AGENT_EXECUTION_ADMIN = 36;
   */
  AGENT_EXECUTION_ADMIN = 36,

  /**
   * @generated from enum value: RESOURCE_ROLE_AGENT_EXECUTION_RUNNER = 37;
   */
  AGENT_EXECUTION_RUNNER = 37,

  /**
   * @generated from enum value: RESOURCE_ROLE_AGENT_EXECUTION_OUTPUTS_REPORTER = 46;
   */
  AGENT_EXECUTION_OUTPUTS_REPORTER = 46,

  /**
   * @generated from enum value: RESOURCE_ROLE_AGENT_EXECUTION_VIEWER = 65;
   */
  AGENT_EXECUTION_VIEWER = 65,

  /**
   * Agent roles
   *
   * @generated from enum value: RESOURCE_ROLE_AGENT_ADMIN = 38;
   */
  AGENT_ADMIN = 38,

  /**
   * @generated from enum value: RESOURCE_ROLE_AGENT_VIEWER = 39;
   */
  AGENT_VIEWER = 39,

  /**
   * @generated from enum value: RESOURCE_ROLE_AGENT_EXECUTOR = 40;
   */
  AGENT_EXECUTOR = 40,

  /**
   * Workflow roles
   *
   * @generated from enum value: RESOURCE_ROLE_WORKFLOW_ADMIN = 41;
   */
  WORKFLOW_ADMIN = 41,

  /**
   * @generated from enum value: RESOURCE_ROLE_WORKFLOW_USER = 42;
   */
  WORKFLOW_USER = 42,

  /**
   * @generated from enum value: RESOURCE_ROLE_WORKFLOW_VIEWER = 43;
   */
  WORKFLOW_VIEWER = 43,

  /**
   * @generated from enum value: RESOURCE_ROLE_WORKFLOW_EXECUTOR = 47;
   */
  WORKFLOW_EXECUTOR = 47,

  /**
   * Snapshot roles
   *
   * @generated from enum value: RESOURCE_ROLE_SNAPSHOT_ADMIN = 44;
   */
  SNAPSHOT_ADMIN = 44,

  /**
   * @generated from enum value: RESOURCE_ROLE_SNAPSHOT_RUNNER = 45;
   */
  SNAPSHOT_RUNNER = 45,

  /**
   * Webhook roles
   *
   * @generated from enum value: RESOURCE_ROLE_WEBHOOK_ADMIN = 48;
   */
  WEBHOOK_ADMIN = 48,

  /**
   * @generated from enum value: RESOURCE_ROLE_WEBHOOK_VIEWER = 49;
   */
  WEBHOOK_VIEWER = 49,

  /**
   * @generated from enum value: RESOURCE_ROLE_WARMPOOL_RUNNER = 54;
   */
  WARMPOOL_RUNNER = 54,

  /**
   * @generated from enum value: RESOURCE_ROLE_WARMPOOL_ADMIN = 55;
   */
  WARMPOOL_ADMIN = 55,

  /**
   * @generated from enum value: RESOURCE_ROLE_WARMPOOL_VIEWER = 56;
   */
  WARMPOOL_VIEWER = 56,

  /**
   * Session roles
   *
   * @generated from enum value: RESOURCE_ROLE_SESSION_ADMIN = 60;
   */
  SESSION_ADMIN = 60,

  /**
   * @generated from enum value: RESOURCE_ROLE_SESSION_USER = 61;
   */
  SESSION_USER = 61,

  /**
   * @generated from enum value: RESOURCE_ROLE_TEAM_ADMIN = 62;
   */
  TEAM_ADMIN = 62,

  /**
   * @generated from enum value: RESOURCE_ROLE_TEAM_VIEWER = 63;
   */
  TEAM_VIEWER = 63,
}
// Retrieve enum metadata with: proto3.getEnumType(ResourceRole)
proto3.util.setEnumType(ResourceRole, "gitpod.v1.ResourceRole", [
  { no: 0, name: "RESOURCE_ROLE_UNSPECIFIED" },
  { no: 1, name: "RESOURCE_ROLE_ORG_ADMIN" },
  { no: 2, name: "RESOURCE_ROLE_ORG_MEMBER" },
  { no: 50, name: "RESOURCE_ROLE_ORG_RUNNERS_ADMIN" },
  { no: 51, name: "RESOURCE_ROLE_ORG_PROJECTS_ADMIN" },
  { no: 52, name: "RESOURCE_ROLE_ORG_AUTOMATIONS_ADMIN" },
  { no: 53, name: "RESOURCE_ROLE_ORG_GROUPS_ADMIN" },
  { no: 64, name: "RESOURCE_ROLE_ORG_AUDIT_LOG_READER" },
  { no: 3, name: "RESOURCE_ROLE_GROUP_ADMIN" },
  { no: 4, name: "RESOURCE_ROLE_GROUP_VIEWER" },
  { no: 5, name: "RESOURCE_ROLE_USER_IDENTITY" },
  { no: 6, name: "RESOURCE_ROLE_USER_VIEWER" },
  { no: 7, name: "RESOURCE_ROLE_USER_ADMIN" },
  { no: 8, name: "RESOURCE_ROLE_ENVIRONMENT_IDENTITY" },
  { no: 9, name: "RESOURCE_ROLE_ENVIRONMENT_ADMIN" },
  { no: 10, name: "RESOURCE_ROLE_ENVIRONMENT_USER" },
  { no: 11, name: "RESOURCE_ROLE_ENVIRONMENT_VIEWER" },
  { no: 12, name: "RESOURCE_ROLE_ENVIRONMENT_RUNNER" },
  { no: 13, name: "RESOURCE_ROLE_RUNNER_IDENTITY" },
  { no: 14, name: "RESOURCE_ROLE_RUNNER_ADMIN" },
  { no: 15, name: "RESOURCE_ROLE_RUNNER_LOCAL_ADMIN" },
  { no: 16, name: "RESOURCE_ROLE_RUNNER_MANAGED_ADMIN" },
  { no: 17, name: "RESOURCE_ROLE_RUNNER_USER" },
  { no: 18, name: "RESOURCE_ROLE_RUNNER_CONFIGURATION_READER" },
  { no: 19, name: "RESOURCE_ROLE_HOST_AUTHENTICATION_TOKEN_ADMIN" },
  { no: 20, name: "RESOURCE_ROLE_HOST_AUTHENTICATION_TOKEN_UPDATER" },
  { no: 21, name: "RESOURCE_ROLE_PROJECT_ADMIN" },
  { no: 22, name: "RESOURCE_ROLE_PROJECT_USER" },
  { no: 23, name: "RESOURCE_ROLE_PROJECT_EDITOR" },
  { no: 24, name: "RESOURCE_ROLE_ENVIRONMENT_SERVICE_ADMIN" },
  { no: 25, name: "RESOURCE_ROLE_ENVIRONMENT_SERVICE_VIEWER" },
  { no: 26, name: "RESOURCE_ROLE_ENVIRONMENT_SERVICE_USER" },
  { no: 27, name: "RESOURCE_ROLE_ENVIRONMENT_SERVICE_ENV" },
  { no: 28, name: "RESOURCE_ROLE_ENVIRONMENT_TASK_ADMIN" },
  { no: 29, name: "RESOURCE_ROLE_ENVIRONMENT_TASK_VIEWER" },
  { no: 30, name: "RESOURCE_ROLE_ENVIRONMENT_TASK_USER" },
  { no: 31, name: "RESOURCE_ROLE_ENVIRONMENT_TASK_ENV" },
  { no: 32, name: "RESOURCE_ROLE_SERVICE_ACCOUNT_IDENTITY" },
  { no: 33, name: "RESOURCE_ROLE_SERVICE_ACCOUNT_ADMIN" },
  { no: 35, name: "RESOURCE_ROLE_AGENT_EXECUTION_USER" },
  { no: 36, name: "RESOURCE_ROLE_AGENT_EXECUTION_ADMIN" },
  { no: 37, name: "RESOURCE_ROLE_AGENT_EXECUTION_RUNNER" },
  { no: 46, name: "RESOURCE_ROLE_AGENT_EXECUTION_OUTPUTS_REPORTER" },
  { no: 65, name: "RESOURCE_ROLE_AGENT_EXECUTION_VIEWER" },
  { no: 38, name: "RESOURCE_ROLE_AGENT_ADMIN" },
  { no: 39, name: "RESOURCE_ROLE_AGENT_VIEWER" },
  { no: 40, name: "RESOURCE_ROLE_AGENT_EXECUTOR" },
  { no: 41, name: "RESOURCE_ROLE_WORKFLOW_ADMIN" },
  { no: 42, name: "RESOURCE_ROLE_WORKFLOW_USER" },
  { no: 43, name: "RESOURCE_ROLE_WORKFLOW_VIEWER" },
  { no: 47, name: "RESOURCE_ROLE_WORKFLOW_EXECUTOR" },
  { no: 44, name: "RESOURCE_ROLE_SNAPSHOT_ADMIN" },
  { no: 45, name: "RESOURCE_ROLE_SNAPSHOT_RUNNER" },
  { no: 48, name: "RESOURCE_ROLE_WEBHOOK_ADMIN" },
  { no: 49, name: "RESOURCE_ROLE_WEBHOOK_VIEWER" },
  { no: 54, name: "RESOURCE_ROLE_WARMPOOL_RUNNER" },
  { no: 55, name: "RESOURCE_ROLE_WARMPOOL_ADMIN" },
  { no: 56, name: "RESOURCE_ROLE_WARMPOOL_VIEWER" },
  { no: 60, name: "RESOURCE_ROLE_SESSION_ADMIN" },
  { no: 61, name: "RESOURCE_ROLE_SESSION_USER" },
  { no: 62, name: "RESOURCE_ROLE_TEAM_ADMIN" },
  { no: 63, name: "RESOURCE_ROLE_TEAM_VIEWER" },
]);

/**
 * @generated from message gitpod.v1.ListGroupsRequest
 */
export class ListGroupsRequest extends Message<ListGroupsRequest> {
  /**
   * pagination contains the pagination options for listing groups
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains options for filtering the list of groups.
   *
   * @generated from field: gitpod.v1.ListGroupsRequest.Filter filter = 2;
   */
  filter?: ListGroupsRequest_Filter;

  constructor(data?: PartialMessage<ListGroupsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListGroupsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListGroupsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListGroupsRequest {
    return new ListGroupsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListGroupsRequest {
    return new ListGroupsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListGroupsRequest {
    return new ListGroupsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListGroupsRequest | PlainMessage<ListGroupsRequest> | undefined, b: ListGroupsRequest | PlainMessage<ListGroupsRequest> | undefined): boolean {
    return proto3.util.equals(ListGroupsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListGroupsRequest.Filter
 */
export class ListGroupsRequest_Filter extends Message<ListGroupsRequest_Filter> {
  /**
   * search performs case-insensitive search across group name, description, and ID
   *
   * @generated from field: string search = 1;
   */
  search = "";

  /**
   * group_ids filters the response to only groups with the specified IDs
   *
   * @generated from field: repeated string group_ids = 2;
   */
  groupIds: string[] = [];

  /**
   * system_managed filters groups by their system_managed flag.
   * When set, only groups matching this value are returned.
   *
   * @generated from field: optional bool system_managed = 3;
   */
  systemManaged?: boolean;

  /**
   * direct_share filters groups by their direct_share flag.
   * When set, only groups matching this value are returned.
   *
   * @generated from field: optional bool direct_share = 4;
   */
  directShare?: boolean;

  constructor(data?: PartialMessage<ListGroupsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListGroupsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "system_managed", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 4, name: "direct_share", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListGroupsRequest_Filter {
    return new ListGroupsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListGroupsRequest_Filter {
    return new ListGroupsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListGroupsRequest_Filter {
    return new ListGroupsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListGroupsRequest_Filter | PlainMessage<ListGroupsRequest_Filter> | undefined, b: ListGroupsRequest_Filter | PlainMessage<ListGroupsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListGroupsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListGroupsResponse
 */
export class ListGroupsResponse extends Message<ListGroupsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Group groups = 2;
   */
  groups: Group[] = [];

  constructor(data?: PartialMessage<ListGroupsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListGroupsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "groups", kind: "message", T: Group, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListGroupsResponse {
    return new ListGroupsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListGroupsResponse {
    return new ListGroupsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListGroupsResponse {
    return new ListGroupsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListGroupsResponse | PlainMessage<ListGroupsResponse> | undefined, b: ListGroupsResponse | PlainMessage<ListGroupsResponse> | undefined): boolean {
    return proto3.util.equals(ListGroupsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Group
 */
export class Group extends Message<Group> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * system_managed indicates that this group is created by the system automatically
   *
   * @generated from field: bool system_managed = 4;
   */
  systemManaged = false;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string description = 7;
   */
  description = "";

  /**
   * member_count is the total number of members in this group
   *
   * @generated from field: int32 member_count = 8;
   */
  memberCount = 0;

  /**
   * direct_share indicates that this group is used for direct user sharing on resources.
   * These groups are hidden from regular group listings.
   *
   * @generated from field: bool direct_share = 9;
   */
  directShare = false;

  constructor(data?: PartialMessage<Group>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Group";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "system_managed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "member_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "direct_share", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Group {
    return new Group().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Group {
    return new Group().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Group {
    return new Group().fromJsonString(jsonString, options);
  }

  static equals(a: Group | PlainMessage<Group> | undefined, b: Group | PlainMessage<Group> | undefined): boolean {
    return proto3.util.equals(Group, a, b);
  }
}

/**
 * GroupMembership represents a subject's membership in a group
 *
 * @generated from message gitpod.v1.GroupMembership
 */
export class GroupMembership extends Message<GroupMembership> {
  /**
   * Unique identifier for the group membership
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Subject (user, runner, environment, service account, etc.)
   *
   * @generated from field: gitpod.v1.Subject subject = 2;
   */
  subject?: Subject;

  /**
   * Group identifier
   *
   * @generated from field: string group_id = 3;
   */
  groupId = "";

  /**
   * Subject's display name
   *
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * Subject's avatar URL
   *
   * @generated from field: string avatar_url = 5;
   */
  avatarUrl = "";

  constructor(data?: PartialMessage<GroupMembership>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GroupMembership";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "message", T: Subject },
    { no: 3, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GroupMembership {
    return new GroupMembership().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GroupMembership {
    return new GroupMembership().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GroupMembership {
    return new GroupMembership().fromJsonString(jsonString, options);
  }

  static equals(a: GroupMembership | PlainMessage<GroupMembership> | undefined, b: GroupMembership | PlainMessage<GroupMembership> | undefined): boolean {
    return proto3.util.equals(GroupMembership, a, b);
  }
}

/**
 * RoleAssignment represents a role assigned to a group on a specific resource
 *
 * @generated from message gitpod.v1.RoleAssignment
 */
export class RoleAssignment extends Message<RoleAssignment> {
  /**
   * Unique identifier for the role assignment
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Group identifier
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  /**
   * Organization identifier
   *
   * @generated from field: string organization_id = 3;
   */
  organizationId = "";

  /**
   * Resource identifier
   *
   * @generated from field: string resource_id = 4;
   */
  resourceId = "";

  /**
   * Type of resource (runner, project, environment, etc.)
   *
   * @generated from field: gitpod.v1.ResourceType resource_type = 5;
   */
  resourceType = ResourceType.UNSPECIFIED;

  /**
   * Role assigned to the group on this resource
   *
   * @generated from field: gitpod.v1.ResourceRole resource_role = 6;
   */
  resourceRole = ResourceRole.UNSPECIFIED;

  /**
   * The org-level role that created this assignment, if any.
   * RESOURCE_ROLE_UNSPECIFIED means this is a direct share (manually created).
   * Non-zero (e.g., ORG_PROJECTS_ADMIN, ORG_RUNNERS_ADMIN) means this
   * assignment was derived from an org-level role.
   *
   * @generated from field: optional gitpod.v1.ResourceRole derived_from_org_role = 7;
   */
  derivedFromOrgRole?: ResourceRole;

  constructor(data?: PartialMessage<RoleAssignment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RoleAssignment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "resource_type", kind: "enum", T: proto3.getEnumType(ResourceType) },
    { no: 6, name: "resource_role", kind: "enum", T: proto3.getEnumType(ResourceRole) },
    { no: 7, name: "derived_from_org_role", kind: "enum", T: proto3.getEnumType(ResourceRole), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RoleAssignment {
    return new RoleAssignment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RoleAssignment {
    return new RoleAssignment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RoleAssignment {
    return new RoleAssignment().fromJsonString(jsonString, options);
  }

  static equals(a: RoleAssignment | PlainMessage<RoleAssignment> | undefined, b: RoleAssignment | PlainMessage<RoleAssignment> | undefined): boolean {
    return proto3.util.equals(RoleAssignment, a, b);
  }
}

/**
 * CreateGroup messages
 *
 * @generated from message gitpod.v1.CreateGroupRequest
 */
export class CreateGroupRequest extends Message<CreateGroupRequest> {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  constructor(data?: PartialMessage<CreateGroupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateGroupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateGroupRequest {
    return new CreateGroupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateGroupRequest {
    return new CreateGroupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateGroupRequest {
    return new CreateGroupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateGroupRequest | PlainMessage<CreateGroupRequest> | undefined, b: CreateGroupRequest | PlainMessage<CreateGroupRequest> | undefined): boolean {
    return proto3.util.equals(CreateGroupRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateGroupResponse
 */
export class CreateGroupResponse extends Message<CreateGroupResponse> {
  /**
   * @generated from field: gitpod.v1.Group group = 1;
   */
  group?: Group;

  constructor(data?: PartialMessage<CreateGroupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateGroupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group", kind: "message", T: Group },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateGroupResponse {
    return new CreateGroupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateGroupResponse {
    return new CreateGroupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateGroupResponse {
    return new CreateGroupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateGroupResponse | PlainMessage<CreateGroupResponse> | undefined, b: CreateGroupResponse | PlainMessage<CreateGroupResponse> | undefined): boolean {
    return proto3.util.equals(CreateGroupResponse, a, b);
  }
}

/**
 * GetGroup messages
 *
 * @generated from message gitpod.v1.GetGroupRequest
 */
export class GetGroupRequest extends Message<GetGroupRequest> {
  /**
   * Deprecated: use the group oneof instead.
   *
   * @generated from field: string group_id = 1 [deprecated = true];
   * @deprecated
   */
  groupId = "";

  /**
   * An identifier for the group to get.
   *
   * @generated from oneof gitpod.v1.GetGroupRequest.group
   */
  group: {
    /**
     * id looks up the group by its unique ID.
     *
     * @generated from field: string id = 2;
     */
    value: string;
    case: "id";
  } | {
    /**
     * name looks up the group by its name within the caller's organization.
     *
     * @generated from field: string name = 3;
     */
    value: string;
    case: "name";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetGroupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetGroupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "group" },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "group" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGroupRequest {
    return new GetGroupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGroupRequest {
    return new GetGroupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGroupRequest {
    return new GetGroupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGroupRequest | PlainMessage<GetGroupRequest> | undefined, b: GetGroupRequest | PlainMessage<GetGroupRequest> | undefined): boolean {
    return proto3.util.equals(GetGroupRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetGroupResponse
 */
export class GetGroupResponse extends Message<GetGroupResponse> {
  /**
   * @generated from field: gitpod.v1.Group group = 1;
   */
  group?: Group;

  constructor(data?: PartialMessage<GetGroupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetGroupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group", kind: "message", T: Group },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGroupResponse {
    return new GetGroupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGroupResponse {
    return new GetGroupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGroupResponse {
    return new GetGroupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGroupResponse | PlainMessage<GetGroupResponse> | undefined, b: GetGroupResponse | PlainMessage<GetGroupResponse> | undefined): boolean {
    return proto3.util.equals(GetGroupResponse, a, b);
  }
}

/**
 * UpdateGroup messages
 *
 * @generated from message gitpod.v1.UpdateGroupRequest
 */
export class UpdateGroupRequest extends Message<UpdateGroupRequest> {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  constructor(data?: PartialMessage<UpdateGroupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateGroupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateGroupRequest {
    return new UpdateGroupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateGroupRequest {
    return new UpdateGroupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateGroupRequest {
    return new UpdateGroupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateGroupRequest | PlainMessage<UpdateGroupRequest> | undefined, b: UpdateGroupRequest | PlainMessage<UpdateGroupRequest> | undefined): boolean {
    return proto3.util.equals(UpdateGroupRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateGroupResponse
 */
export class UpdateGroupResponse extends Message<UpdateGroupResponse> {
  /**
   * @generated from field: gitpod.v1.Group group = 1;
   */
  group?: Group;

  constructor(data?: PartialMessage<UpdateGroupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateGroupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group", kind: "message", T: Group },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateGroupResponse {
    return new UpdateGroupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateGroupResponse {
    return new UpdateGroupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateGroupResponse {
    return new UpdateGroupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateGroupResponse | PlainMessage<UpdateGroupResponse> | undefined, b: UpdateGroupResponse | PlainMessage<UpdateGroupResponse> | undefined): boolean {
    return proto3.util.equals(UpdateGroupResponse, a, b);
  }
}

/**
 * DeleteGroup messages
 *
 * @generated from message gitpod.v1.DeleteGroupRequest
 */
export class DeleteGroupRequest extends Message<DeleteGroupRequest> {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  constructor(data?: PartialMessage<DeleteGroupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteGroupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteGroupRequest {
    return new DeleteGroupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteGroupRequest {
    return new DeleteGroupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteGroupRequest {
    return new DeleteGroupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteGroupRequest | PlainMessage<DeleteGroupRequest> | undefined, b: DeleteGroupRequest | PlainMessage<DeleteGroupRequest> | undefined): boolean {
    return proto3.util.equals(DeleteGroupRequest, a, b);
  }
}

/**
 * Empty response
 *
 * @generated from message gitpod.v1.DeleteGroupResponse
 */
export class DeleteGroupResponse extends Message<DeleteGroupResponse> {
  constructor(data?: PartialMessage<DeleteGroupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteGroupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteGroupResponse {
    return new DeleteGroupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteGroupResponse {
    return new DeleteGroupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteGroupResponse {
    return new DeleteGroupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteGroupResponse | PlainMessage<DeleteGroupResponse> | undefined, b: DeleteGroupResponse | PlainMessage<DeleteGroupResponse> | undefined): boolean {
    return proto3.util.equals(DeleteGroupResponse, a, b);
  }
}

/**
 * CreateMembership messages
 *
 * @generated from message gitpod.v1.CreateMembershipRequest
 */
export class CreateMembershipRequest extends Message<CreateMembershipRequest> {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  /**
   * Subject to add to the group
   *
   * @generated from field: gitpod.v1.Subject subject = 2;
   */
  subject?: Subject;

  constructor(data?: PartialMessage<CreateMembershipRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateMembershipRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "message", T: Subject },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMembershipRequest {
    return new CreateMembershipRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMembershipRequest {
    return new CreateMembershipRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMembershipRequest {
    return new CreateMembershipRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMembershipRequest | PlainMessage<CreateMembershipRequest> | undefined, b: CreateMembershipRequest | PlainMessage<CreateMembershipRequest> | undefined): boolean {
    return proto3.util.equals(CreateMembershipRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateMembershipResponse
 */
export class CreateMembershipResponse extends Message<CreateMembershipResponse> {
  /**
   * @generated from field: gitpod.v1.GroupMembership member = 1;
   */
  member?: GroupMembership;

  constructor(data?: PartialMessage<CreateMembershipResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateMembershipResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "member", kind: "message", T: GroupMembership },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMembershipResponse {
    return new CreateMembershipResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMembershipResponse {
    return new CreateMembershipResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMembershipResponse {
    return new CreateMembershipResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMembershipResponse | PlainMessage<CreateMembershipResponse> | undefined, b: CreateMembershipResponse | PlainMessage<CreateMembershipResponse> | undefined): boolean {
    return proto3.util.equals(CreateMembershipResponse, a, b);
  }
}

/**
 * DeleteMembership messages
 *
 * @generated from message gitpod.v1.DeleteMembershipRequest
 */
export class DeleteMembershipRequest extends Message<DeleteMembershipRequest> {
  /**
   * The membership to delete
   *
   * @generated from field: string membership_id = 1;
   */
  membershipId = "";

  constructor(data?: PartialMessage<DeleteMembershipRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteMembershipRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "membership_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteMembershipRequest {
    return new DeleteMembershipRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteMembershipRequest {
    return new DeleteMembershipRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteMembershipRequest {
    return new DeleteMembershipRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteMembershipRequest | PlainMessage<DeleteMembershipRequest> | undefined, b: DeleteMembershipRequest | PlainMessage<DeleteMembershipRequest> | undefined): boolean {
    return proto3.util.equals(DeleteMembershipRequest, a, b);
  }
}

/**
 * Empty response
 *
 * @generated from message gitpod.v1.DeleteMembershipResponse
 */
export class DeleteMembershipResponse extends Message<DeleteMembershipResponse> {
  constructor(data?: PartialMessage<DeleteMembershipResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteMembershipResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteMembershipResponse {
    return new DeleteMembershipResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteMembershipResponse {
    return new DeleteMembershipResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteMembershipResponse {
    return new DeleteMembershipResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteMembershipResponse | PlainMessage<DeleteMembershipResponse> | undefined, b: DeleteMembershipResponse | PlainMessage<DeleteMembershipResponse> | undefined): boolean {
    return proto3.util.equals(DeleteMembershipResponse, a, b);
  }
}

/**
 * GetMembership messages
 *
 * @generated from message gitpod.v1.GetMembershipRequest
 */
export class GetMembershipRequest extends Message<GetMembershipRequest> {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  /**
   * Subject to check membership for
   *
   * @generated from field: gitpod.v1.Subject subject = 2;
   */
  subject?: Subject;

  constructor(data?: PartialMessage<GetMembershipRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetMembershipRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "message", T: Subject },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMembershipRequest {
    return new GetMembershipRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMembershipRequest {
    return new GetMembershipRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMembershipRequest {
    return new GetMembershipRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMembershipRequest | PlainMessage<GetMembershipRequest> | undefined, b: GetMembershipRequest | PlainMessage<GetMembershipRequest> | undefined): boolean {
    return proto3.util.equals(GetMembershipRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetMembershipResponse
 */
export class GetMembershipResponse extends Message<GetMembershipResponse> {
  /**
   * The membership if found, nil if subject is not a member
   *
   * @generated from field: gitpod.v1.GroupMembership member = 1;
   */
  member?: GroupMembership;

  constructor(data?: PartialMessage<GetMembershipResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetMembershipResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "member", kind: "message", T: GroupMembership },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMembershipResponse {
    return new GetMembershipResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMembershipResponse {
    return new GetMembershipResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMembershipResponse {
    return new GetMembershipResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMembershipResponse | PlainMessage<GetMembershipResponse> | undefined, b: GetMembershipResponse | PlainMessage<GetMembershipResponse> | undefined): boolean {
    return proto3.util.equals(GetMembershipResponse, a, b);
  }
}

/**
 * ListMemberships messages
 *
 * @generated from message gitpod.v1.ListMembershipsRequest
 */
export class ListMembershipsRequest extends Message<ListMembershipsRequest> {
  /**
   * pagination contains the pagination options for listing memberships
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  /**
   * filter contains options for filtering the list of memberships.
   *
   * @generated from field: gitpod.v1.ListMembershipsRequest.Filter filter = 3;
   */
  filter?: ListMembershipsRequest_Filter;

  constructor(data?: PartialMessage<ListMembershipsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMembershipsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: ListMembershipsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMembershipsRequest {
    return new ListMembershipsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMembershipsRequest {
    return new ListMembershipsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMembershipsRequest {
    return new ListMembershipsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListMembershipsRequest | PlainMessage<ListMembershipsRequest> | undefined, b: ListMembershipsRequest | PlainMessage<ListMembershipsRequest> | undefined): boolean {
    return proto3.util.equals(ListMembershipsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListMembershipsRequest.Filter
 */
export class ListMembershipsRequest_Filter extends Message<ListMembershipsRequest_Filter> {
  /**
   * search performs case-insensitive search across member name, email, ID,
   * and service account name and description
   *
   * @generated from field: string search = 1;
   */
  search = "";

  constructor(data?: PartialMessage<ListMembershipsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMembershipsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMembershipsRequest_Filter {
    return new ListMembershipsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMembershipsRequest_Filter {
    return new ListMembershipsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMembershipsRequest_Filter {
    return new ListMembershipsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListMembershipsRequest_Filter | PlainMessage<ListMembershipsRequest_Filter> | undefined, b: ListMembershipsRequest_Filter | PlainMessage<ListMembershipsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListMembershipsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListMembershipsResponse
 */
export class ListMembershipsResponse extends Message<ListMembershipsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.GroupMembership members = 2;
   */
  members: GroupMembership[] = [];

  constructor(data?: PartialMessage<ListMembershipsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListMembershipsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "members", kind: "message", T: GroupMembership, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMembershipsResponse {
    return new ListMembershipsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMembershipsResponse {
    return new ListMembershipsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMembershipsResponse {
    return new ListMembershipsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListMembershipsResponse | PlainMessage<ListMembershipsResponse> | undefined, b: ListMembershipsResponse | PlainMessage<ListMembershipsResponse> | undefined): boolean {
    return proto3.util.equals(ListMembershipsResponse, a, b);
  }
}

/**
 * CreateRoleAssignment messages
 *
 * @generated from message gitpod.v1.CreateRoleAssignmentRequest
 */
export class CreateRoleAssignmentRequest extends Message<CreateRoleAssignmentRequest> {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  /**
   * @generated from field: gitpod.v1.ResourceType resource_type = 2;
   */
  resourceType = ResourceType.UNSPECIFIED;

  /**
   * @generated from field: string resource_id = 3;
   */
  resourceId = "";

  /**
   * @generated from field: gitpod.v1.ResourceRole resource_role = 4;
   */
  resourceRole = ResourceRole.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateRoleAssignmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRoleAssignmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource_type", kind: "enum", T: proto3.getEnumType(ResourceType) },
    { no: 3, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "resource_role", kind: "enum", T: proto3.getEnumType(ResourceRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRoleAssignmentRequest {
    return new CreateRoleAssignmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRoleAssignmentRequest {
    return new CreateRoleAssignmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRoleAssignmentRequest {
    return new CreateRoleAssignmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRoleAssignmentRequest | PlainMessage<CreateRoleAssignmentRequest> | undefined, b: CreateRoleAssignmentRequest | PlainMessage<CreateRoleAssignmentRequest> | undefined): boolean {
    return proto3.util.equals(CreateRoleAssignmentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRoleAssignmentResponse
 */
export class CreateRoleAssignmentResponse extends Message<CreateRoleAssignmentResponse> {
  /**
   * @generated from field: gitpod.v1.RoleAssignment assignment = 1;
   */
  assignment?: RoleAssignment;

  constructor(data?: PartialMessage<CreateRoleAssignmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRoleAssignmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assignment", kind: "message", T: RoleAssignment },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRoleAssignmentResponse {
    return new CreateRoleAssignmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRoleAssignmentResponse {
    return new CreateRoleAssignmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRoleAssignmentResponse {
    return new CreateRoleAssignmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRoleAssignmentResponse | PlainMessage<CreateRoleAssignmentResponse> | undefined, b: CreateRoleAssignmentResponse | PlainMessage<CreateRoleAssignmentResponse> | undefined): boolean {
    return proto3.util.equals(CreateRoleAssignmentResponse, a, b);
  }
}

/**
 * ListRoleAssignments messages
 *
 * @generated from message gitpod.v1.ListRoleAssignmentsRequest
 */
export class ListRoleAssignmentsRequest extends Message<ListRoleAssignmentsRequest> {
  /**
   * Pagination parameters
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Filter parameters
   *
   * @generated from field: gitpod.v1.ListRoleAssignmentsRequest.Filter filter = 2;
   */
  filter?: ListRoleAssignmentsRequest_Filter;

  constructor(data?: PartialMessage<ListRoleAssignmentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRoleAssignmentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListRoleAssignmentsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRoleAssignmentsRequest {
    return new ListRoleAssignmentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRoleAssignmentsRequest {
    return new ListRoleAssignmentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRoleAssignmentsRequest {
    return new ListRoleAssignmentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRoleAssignmentsRequest | PlainMessage<ListRoleAssignmentsRequest> | undefined, b: ListRoleAssignmentsRequest | PlainMessage<ListRoleAssignmentsRequest> | undefined): boolean {
    return proto3.util.equals(ListRoleAssignmentsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRoleAssignmentsRequest.Filter
 */
export class ListRoleAssignmentsRequest_Filter extends Message<ListRoleAssignmentsRequest_Filter> {
  /**
   * resource_types filters the response to only role assignments for these resource types
   *
   * @generated from field: repeated gitpod.v1.ResourceType resource_types = 1;
   */
  resourceTypes: ResourceType[] = [];

  /**
   * resource_roles filters the response to only role assignments with these specific roles
   *
   * @generated from field: repeated gitpod.v1.ResourceRole resource_roles = 2;
   */
  resourceRoles: ResourceRole[] = [];

  /**
   * group_id filters the response to only role assignments for this specific group
   * Empty string is allowed and means no filtering by group
   *
   * @generated from field: string group_id = 3;
   */
  groupId = "";

  /**
   * user_id filters the response to only role assignments for groups that this user is a member of
   * Empty string is allowed and means no filtering by user
   *
   * @generated from field: string user_id = 4;
   */
  userId = "";

  /**
   * Filters by a single resource. Non-admin callers with :grant permission
   * on the resource can see role assignments from groups they don't belong to.
   * Mutually exclusive with resource_ids.
   *
   * @generated from field: string resource_id = 5;
   */
  resourceId = "";

  /**
   * Filters by multiple resources in a single request. Non-admin callers with
   * :grant permission on a resource can see all role assignments for that
   * resource, even from groups they don't belong to. The :grant check is
   * applied per-resource within the batch.
   * Mutually exclusive with resource_id.
   *
   * @generated from field: repeated string resource_ids = 6;
   */
  resourceIds: string[] = [];

  constructor(data?: PartialMessage<ListRoleAssignmentsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRoleAssignmentsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_types", kind: "enum", T: proto3.getEnumType(ResourceType), repeated: true },
    { no: 2, name: "resource_roles", kind: "enum", T: proto3.getEnumType(ResourceRole), repeated: true },
    { no: 3, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "resource_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRoleAssignmentsRequest_Filter {
    return new ListRoleAssignmentsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRoleAssignmentsRequest_Filter {
    return new ListRoleAssignmentsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRoleAssignmentsRequest_Filter {
    return new ListRoleAssignmentsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRoleAssignmentsRequest_Filter | PlainMessage<ListRoleAssignmentsRequest_Filter> | undefined, b: ListRoleAssignmentsRequest_Filter | PlainMessage<ListRoleAssignmentsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListRoleAssignmentsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRoleAssignmentsResponse
 */
export class ListRoleAssignmentsResponse extends Message<ListRoleAssignmentsResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.RoleAssignment assignments = 2;
   */
  assignments: RoleAssignment[] = [];

  constructor(data?: PartialMessage<ListRoleAssignmentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRoleAssignmentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "assignments", kind: "message", T: RoleAssignment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRoleAssignmentsResponse {
    return new ListRoleAssignmentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRoleAssignmentsResponse {
    return new ListRoleAssignmentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRoleAssignmentsResponse {
    return new ListRoleAssignmentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRoleAssignmentsResponse | PlainMessage<ListRoleAssignmentsResponse> | undefined, b: ListRoleAssignmentsResponse | PlainMessage<ListRoleAssignmentsResponse> | undefined): boolean {
    return proto3.util.equals(ListRoleAssignmentsResponse, a, b);
  }
}

/**
 * DeleteRoleAssignment messages
 *
 * @generated from message gitpod.v1.DeleteRoleAssignmentRequest
 */
export class DeleteRoleAssignmentRequest extends Message<DeleteRoleAssignmentRequest> {
  /**
   * @generated from field: string assignment_id = 1;
   */
  assignmentId = "";

  constructor(data?: PartialMessage<DeleteRoleAssignmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRoleAssignmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assignment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRoleAssignmentRequest {
    return new DeleteRoleAssignmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRoleAssignmentRequest {
    return new DeleteRoleAssignmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRoleAssignmentRequest {
    return new DeleteRoleAssignmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRoleAssignmentRequest | PlainMessage<DeleteRoleAssignmentRequest> | undefined, b: DeleteRoleAssignmentRequest | PlainMessage<DeleteRoleAssignmentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteRoleAssignmentRequest, a, b);
  }
}

/**
 * Empty response
 *
 * @generated from message gitpod.v1.DeleteRoleAssignmentResponse
 */
export class DeleteRoleAssignmentResponse extends Message<DeleteRoleAssignmentResponse> {
  constructor(data?: PartialMessage<DeleteRoleAssignmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRoleAssignmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRoleAssignmentResponse {
    return new DeleteRoleAssignmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRoleAssignmentResponse {
    return new DeleteRoleAssignmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRoleAssignmentResponse {
    return new DeleteRoleAssignmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRoleAssignmentResponse | PlainMessage<DeleteRoleAssignmentResponse> | undefined, b: DeleteRoleAssignmentResponse | PlainMessage<DeleteRoleAssignmentResponse> | undefined): boolean {
    return proto3.util.equals(DeleteRoleAssignmentResponse, a, b);
  }
}

/**
 * ShareResourceWithPrincipal messages
 *
 * @generated from message gitpod.v1.ShareResourceWithPrincipalRequest
 */
export class ShareResourceWithPrincipalRequest extends Message<ShareResourceWithPrincipalRequest> {
  /**
   * Type of resource to share (runner, project, etc.)
   *
   * @generated from field: gitpod.v1.ResourceType resource_type = 1;
   */
  resourceType = ResourceType.UNSPECIFIED;

  /**
   * ID of the resource to share
   *
   * @generated from field: string resource_id = 2;
   */
  resourceId = "";

  /**
   * Type of principal to share with (user or service account)
   *
   * @generated from field: gitpod.v1.Principal principal = 3;
   */
  principal = Principal.UNSPECIFIED;

  /**
   * ID of the principal (user or service account) to share with
   *
   * @generated from field: string principal_id = 4;
   */
  principalId = "";

  /**
   * Role to grant the principal on the resource
   *
   * @generated from field: gitpod.v1.ResourceRole role = 5;
   */
  role = ResourceRole.UNSPECIFIED;

  constructor(data?: PartialMessage<ShareResourceWithPrincipalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ShareResourceWithPrincipalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_type", kind: "enum", T: proto3.getEnumType(ResourceType) },
    { no: 2, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "principal", kind: "enum", T: proto3.getEnumType(Principal) },
    { no: 4, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "role", kind: "enum", T: proto3.getEnumType(ResourceRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShareResourceWithPrincipalRequest {
    return new ShareResourceWithPrincipalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShareResourceWithPrincipalRequest {
    return new ShareResourceWithPrincipalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShareResourceWithPrincipalRequest {
    return new ShareResourceWithPrincipalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ShareResourceWithPrincipalRequest | PlainMessage<ShareResourceWithPrincipalRequest> | undefined, b: ShareResourceWithPrincipalRequest | PlainMessage<ShareResourceWithPrincipalRequest> | undefined): boolean {
    return proto3.util.equals(ShareResourceWithPrincipalRequest, a, b);
  }
}

/**
 * Empty response on success
 *
 * @generated from message gitpod.v1.ShareResourceWithPrincipalResponse
 */
export class ShareResourceWithPrincipalResponse extends Message<ShareResourceWithPrincipalResponse> {
  constructor(data?: PartialMessage<ShareResourceWithPrincipalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ShareResourceWithPrincipalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShareResourceWithPrincipalResponse {
    return new ShareResourceWithPrincipalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShareResourceWithPrincipalResponse {
    return new ShareResourceWithPrincipalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShareResourceWithPrincipalResponse {
    return new ShareResourceWithPrincipalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ShareResourceWithPrincipalResponse | PlainMessage<ShareResourceWithPrincipalResponse> | undefined, b: ShareResourceWithPrincipalResponse | PlainMessage<ShareResourceWithPrincipalResponse> | undefined): boolean {
    return proto3.util.equals(ShareResourceWithPrincipalResponse, a, b);
  }
}

/**
 * UnshareResourceWithPrincipal messages
 *
 * @generated from message gitpod.v1.UnshareResourceWithPrincipalRequest
 */
export class UnshareResourceWithPrincipalRequest extends Message<UnshareResourceWithPrincipalRequest> {
  /**
   * Type of resource to unshare
   *
   * @generated from field: gitpod.v1.ResourceType resource_type = 1;
   */
  resourceType = ResourceType.UNSPECIFIED;

  /**
   * ID of the resource to unshare
   *
   * @generated from field: string resource_id = 2;
   */
  resourceId = "";

  /**
   * Type of principal to remove access from (user or service account)
   *
   * @generated from field: gitpod.v1.Principal principal = 3;
   */
  principal = Principal.UNSPECIFIED;

  /**
   * ID of the principal (user or service account) to remove access from
   *
   * @generated from field: string principal_id = 4;
   */
  principalId = "";

  constructor(data?: PartialMessage<UnshareResourceWithPrincipalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UnshareResourceWithPrincipalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_type", kind: "enum", T: proto3.getEnumType(ResourceType) },
    { no: 2, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "principal", kind: "enum", T: proto3.getEnumType(Principal) },
    { no: 4, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnshareResourceWithPrincipalRequest {
    return new UnshareResourceWithPrincipalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnshareResourceWithPrincipalRequest {
    return new UnshareResourceWithPrincipalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnshareResourceWithPrincipalRequest {
    return new UnshareResourceWithPrincipalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UnshareResourceWithPrincipalRequest | PlainMessage<UnshareResourceWithPrincipalRequest> | undefined, b: UnshareResourceWithPrincipalRequest | PlainMessage<UnshareResourceWithPrincipalRequest> | undefined): boolean {
    return proto3.util.equals(UnshareResourceWithPrincipalRequest, a, b);
  }
}

/**
 * Empty response on success
 *
 * @generated from message gitpod.v1.UnshareResourceWithPrincipalResponse
 */
export class UnshareResourceWithPrincipalResponse extends Message<UnshareResourceWithPrincipalResponse> {
  constructor(data?: PartialMessage<UnshareResourceWithPrincipalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UnshareResourceWithPrincipalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UnshareResourceWithPrincipalResponse {
    return new UnshareResourceWithPrincipalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UnshareResourceWithPrincipalResponse {
    return new UnshareResourceWithPrincipalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UnshareResourceWithPrincipalResponse {
    return new UnshareResourceWithPrincipalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UnshareResourceWithPrincipalResponse | PlainMessage<UnshareResourceWithPrincipalResponse> | undefined, b: UnshareResourceWithPrincipalResponse | PlainMessage<UnshareResourceWithPrincipalResponse> | undefined): boolean {
    return proto3.util.equals(UnshareResourceWithPrincipalResponse, a, b);
  }
}

